import { protectedRoute } from '@/modules/core/root/protected/route';
import { createRoute, Outlet } from '@tanstack/react-router';

export const chargeCenterRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'charge-center',
  component: chargeCenterLayout,
});

function chargeCenterLayout() {
  return <Outlet />;
}
